<script lang="ts">
  // The location arrow beside a place name that is the phone's own position,
  // in both headers. The name is the city; this says it is where you are.
</script>

<span class="here-mark" role="img" aria-label="My location" title="My location">
  <svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true">
    <path d="M21 3 3 10.5l7.5 3 3 7.5z" fill="currentColor" />
  </svg>
</span>

<style>
  .here-mark {
    display: inline-grid;
    place-items: center;
    /* The hero sets this to its own ink: an accent arrow on an accent
       field is invisible. */
    color: var(--here-mark, var(--color-accent));
    margin-right: 5px;
    vertical-align: -1px;
  }
</style>
